// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2wJ0r","selected":"Chip_selected__3uWZ-"};